import { render, staticRenderFns } from "./faceStudentstatistics.vue?vue&type=template&id=517944af"
import script from "./faceStudentstatistics.vue?vue&type=script&lang=js"
export * from "./faceStudentstatistics.vue?vue&type=script&lang=js"
import style0 from "./faceStudentstatistics.vue?vue&type=style&index=0&id=517944af&prod&lang=less&scope=true"
import style1 from "./faceStudentstatistics.vue?vue&type=style&index=1&id=517944af&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports